/*eslint-disable*/
import React from 'react'

const scrollHandle = <div style={{width: '12px', height: '12px', background: '#999'}}></div>

export const propsScroller = {
  scrollHandle,
  events: {
    handleScrollLeftClick: () => console.log('handleScrollLeftClick'), 
    handleScrollRightClick: () => console.log('handleScrollRightClick'),
    handleDrag: () => console.log('handleDrag'), 
    resetDragOverride: () => console.log('resetDragOverride')
  },
  headers: [0,1,2,3,4,5],
  mobile: false,
  position: null,
  rowActions: {enabled: false, comparator: "actionBuilder"},
  setOffset: offset => console.log('setOffset', offset),
  width: {paddingLeft: "40px", paddingRight: "40px"}
}